import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const WhatsIncluded = ({ items }) => {
  return (
    <section className="relative py-16 md:py-20 bg-[#F7F1EA] overflow-hidden">
      {/* BG GLOWS */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#E8C8A7]/25 blur-3xl rounded-full" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#DDBA99]/20 blur-3xl rounded-full" />

      <div className="relative max-w-[1280px] mx-auto px-6">
        {/* HEADER */}
        <div className="text-center mb-12">
          <div
            className="
              inline-flex
              items-center
              px-4
              py-2
              rounded-full
              bg-[#FFF4E8]
              border
              border-[#F3DDC7]
              text-primary
              text-[11px]
              tracking-[.18em]
              uppercase
              font-medium
              mb-4
            "
          >
            Retreat Experience
          </div>

          <h2
            className="
              text-3xl
              md:text-5xl
              font-bold
              text-secondary
              mb-5
            "
          >
            What’s Included
          </h2>

          <p
            className="
              max-w-[700px]
              mx-auto
              text-[#5F5751]
              text-sm
              md:text-base
              leading-7
            "
          >
            Carefully curated experiences,
            wellness practices, immersive
            sessions, and transformative
            moments designed to help you
            reconnect, recharge, and thrive.
          </p>
        </div>

        {/* GRID */}
        <div
          className="
            grid
            grid-cols-1
            sm:grid-cols-2
            xl:grid-cols-3
            gap-5
          "
        >
          {items.map((item, index) => (
            <div
              key={index}
              className="
                relative
                overflow-hidden
                rounded-[28px]
                bg-white/75
                backdrop-blur-xl
                border
                border-white/40
                shadow-[0_15px_40px_rgba(20,10,0,.05)]
                p-5
                transition-all
                duration-500
                hover:-translate-y-1
              "
            >
              {/* GLOW */}
              <div
                className="
                  absolute
                  top-0
                  right-0
                  w-32
                  h-32
                  bg-[#F4D8BE]/20
                  blur-3xl
                  rounded-full
                "
              />

              <div className="relative z-10">
                {/* ICON */}
                <div
                  className="
                    w-12
                    h-12
                    rounded-full
                    bg-[#FFF4E8]
                    border
                    border-[#F3DDC7]
                    flex
                    items-center
                    justify-center
                    mb-4
                  "
                >
                  <FontAwesomeIcon
                    icon={item.icon}
                    className="
                      text-primary
                      text-lg
                    "
                  />
                </div>

                {/* TEXT */}
                <p
                  className="
                    text-[#2A140D]
                    text-sm
                    md:text-base
                    leading-7
                  "
                >
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatsIncluded;